import SuspicionTableService from 'app/admin/suspicion/service/SuspicionTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'suspicionTable',
	text: 'Suspicion',
	topic: 'suspicion',
	service: SuspicionTableService,
	icon: 'person',
	editFormState: item => `/suspicion/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'search', 'refresh', 'new'],
	filterFields: [],
	toolbarSearchFieldKey: 'name',
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'name',
			text: 'Name',
			textKey: 'name',
			type: 'text',
			disablePadding: false
		},
		{
			key: 'timeLimit',
			text: 'Time limit',
			textKey: 'timeLimit',
			type: 'text',
			disablePadding: false
		},
		{
			key: 'countLimit',
			text: 'Count limit',
			textKey: 'countLimit',
			type: 'text',
			disablePadding: false
		}
	]
};

function SuspicionTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('suspicionTable', reducer('suspicionTable'))(SuspicionTable);
